import type { StyleRule } from '@archipro-design/aria';
import { pxToRem, pxArrayToRem, captionClassName } from '@archipro-design/aria';

export const BannerContainer: StyleRule = ({ theme }) => ({
    position: 'relative',
    right: pxToRem(3),
    padding: pxArrayToRem([10, 30]),
    margin: pxArrayToRem([0, 18, 16, 18]),
    backgroundColor: theme.siteVariables.colors.white['200A'],
    textAlign: 'center',

    '& > *': {
        fontSize: `${pxToRem(15)} !important`,
        lineHeight: pxToRem(24),
    },

    [theme.screen.tablet]: {
        right: 0,
        width: '100%',
        height: pxToRem(68),
        margin: pxArrayToRem([0, 0, 39, 0]),
        '& > *': {
            fontSize: `${theme.siteVariables.fontSizes.caption02} !important`,
        },
        [`& .${captionClassName}`]: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100%',
        },
    },
});

export const SignInButton: StyleRule = ({ theme }) => ({
    padding: 0,
    textDecoration: 'underline',
    textDecorationSkipInk: 'auto',
    textUnderlineOffset: '2px',
    color: theme.siteVariables.colors.primitive.black,
    border: 'none',
    cursor: 'pointer',
    marginRight: pxToRem(4),
});
